import { slideDown, slideUp } from '../core/effects.js';

function setCookie(name, value, days) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
}

function getCookie(name) {
  const matches = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function initCookieNotice() {
  const cookieNote = document.querySelector('.cookie-form');

  if (!cookieNote || cookieNote.dataset.webtenseCookieInit) {
    return;
  }

  cookieNote.dataset.webtenseCookieInit = 'true';
  const acceptButton = cookieNote.querySelector('.cookie__accept');
  if (!acceptButton) {
    return;
  }

  acceptButton.addEventListener('click', () => {
    setCookie('cookiePrivacy', 'true', 365);
    slideUp(cookieNote, 500);
  });

  if (!getCookie('cookiePrivacy')) {
    setTimeout(() => {
      slideDown(cookieNote, 500);
    }, 7000);
  }
}
